import './index.css'

import { startVersionWatch } from '@polf/shared/app-version'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import ErrorBoundary from './ErrorBoundary'
// Importing pwa registers the service worker on every load, even when the
// shell never renders (see src/pwa.ts).
import { prepareAppUpdate } from './pwa'

// Tabs from old SMS links stay open for days; this moves them onto the
// current build at a moment where reloading costs nothing (design.md §8.5).
startVersionWatch({
  currentBuildId: __APP_BUILD_ID__,
  prepareUpdate: () => prepareAppUpdate(),
})

const root = document.getElementById('root')
if (!root) throw new Error('#root not found')

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
)
